import { getLocalStorage, updateLocalStorege } from "data/cache/localstorage-cache";
import { TableDescriptions } from "../@types/interfaces/table-interface";
import { getParameterUrlByName } from "./request-helper";

export function checkColumns(localStorageColumnsName: string, ColunmsTableAdapter: TableDescriptions[]) {
  let localStorageColumns: TableDescriptions[] = getLocalStorage(localStorageColumnsName);
  let columnsAdapter: TableDescriptions[] = ColunmsTableAdapter.map((column) => ({
    ...column,
    ordination: column.ordination ? { ...column.ordination } : undefined,
  }));
  let newColumns: TableDescriptions[] = []

  if (localStorageColumns !== null) {
    let nextOrder =
      localStorageColumns.reduce((maxOrder, columnLocalstorage) => {
        const order =
          typeof columnLocalstorage.order === 'number'
            ? columnLocalstorage.order
            : 0;
        return order > maxOrder ? order : maxOrder;
      }, -1) + 1;

    newColumns = columnsAdapter.map(columnAdapter => {
      const columnLocalstorage = localStorageColumns.find(col =>
        col.dataField === columnAdapter.dataField || col.text === columnAdapter.text
      );

      if (columnLocalstorage) {
        return {
          ...columnAdapter,
          hidden: columnLocalstorage.hidden ?? columnAdapter.hidden,
          order:
            typeof columnLocalstorage.order === 'number'
              ? columnLocalstorage.order
              : columnAdapter.order,
        };
      }

      return {
        ...columnAdapter,
        order: nextOrder++,
      };
    });

    updateLocalStorege(
      localStorageColumnsName,
      newColumns.sort((a, b) => {
        const oa = typeof a.order === 'number' ? a.order : 0;
        const ob = typeof b.order === 'number' ? b.order : 0;
        return oa - ob;
      })
    );
  }
}

export async function orderValueColums(nameColumn: TableDescriptions, localStorageColumnsName: string, columns: TableDescriptions[],
  totalPageSize: number, handleTableFucntion: (() => void), nextPagination: string) {
  /** busca no localstorage */
  let localStorageColumsOrder: any[] = getLocalStorage(localStorageColumnsName) ?? [];

  columns.forEach((value) => {
    if (value.id === nameColumn.id) {
      if (localStorageColumsOrder.length === 0) {
        value.ordination!.ordinationValue = 'asc';
        localStorageColumsOrder[0] = value.ordination;
        updateLocalStorege(localStorageColumnsName, localStorageColumsOrder);
      } else {
        if (value.ordination?.ordinationValue === 'asc') {
          value.ordination!.ordinationValue = 'desc';
          localStorageColumsOrder[0] = value.ordination;
          updateLocalStorege(localStorageColumnsName, localStorageColumsOrder);
        } else if (value.ordination?.ordinationValue === 'desc') {
          value.ordination!.ordinationValue = '';
          localStorageColumsOrder[0] = value.ordination;
          updateLocalStorege(localStorageColumnsName, localStorageColumsOrder);
        } else if (value.ordination?.ordinationValue === '') {
          value.ordination!.ordinationValue = 'asc';
          localStorageColumsOrder[0] = value.ordination;
          updateLocalStorege(localStorageColumnsName, localStorageColumsOrder);
        }
      }
    } else {
      if (value.ordination !== undefined && value.ordination !== null) {
        value.ordination!.ordinationValue = '';
      }
    }
  });
  /** chama o endpoint */
  totalPageSize = Number(getParameterUrlByName('size', nextPagination))!;
  await handleTableFucntion()
}
